(() => {

  const moneyFormatter = (currency) => {

    try {

      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {

        style: 'currency',

        currency

      });

    } catch (error) {

      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

    }

  };



  const initBuilder = (root) => {

    if (!root || root.dataset.builderInitialized === 'true') return;

    root.dataset.builderInitialized = 'true';



    const currency = root.dataset.currency || 'USD';

    const formatMoney = moneyFormatter(currency);



    if (root.dataset.hideFooter === 'true') {

      document.body.classList.add('tsob-steak-landing--hide-footer');

    }

    const threshold = Number(root.dataset.freeShippingThreshold || 25000);

    let cartTotal = Number(root.dataset.cartTotal || 0);

    let cartItemCount = Number(root.dataset.cartCount || 0);

    const selections = new Map();
    let cartRequestInFlight = false;



    const drawer = root.querySelector('[data-builder-drawer]');

    const backdrop = root.querySelector('[data-builder-drawer-backdrop]');

    const mobileBar = root.querySelector('[data-builder-mobile-bar]');

    const drawerOpenControl = root.querySelector('[data-builder-drawer-open]');

    const desktopSummary = root.querySelector('.tsob-builder-summary');



    /*

      The TSOB header hides while scrolling down and returns while scrolling up.

      The desktop order summary is sticky too, so a fixed top value can place it

      underneath the reappearing header. Measure the part of the sticky header

      that is actually visible and keep the order summary just below it.

    */

    const getVisibleHeaderBottom = () => {

      const candidates = document.querySelectorAll(

        'sticky-header, .header-wrapper, .shopify-section-group-header-group, header.header, [data-sticky-header]'

      );



      let visibleBottom = 0;



      candidates.forEach((element) => {

        if (!(element instanceof HTMLElement)) return;



        const style = window.getComputedStyle(element);

        if (

          style.display === 'none' ||

          style.visibility === 'hidden' ||

          Number(style.opacity || 1) === 0

        ) {

          return;

        }



        const rect = element.getBoundingClientRect();

        if (rect.bottom <= 0 || rect.top >= window.innerHeight) return;



        const stickyAncestor = element.closest('sticky-header, [data-sticky-header]');

        const isStickyLike =

          style.position === 'fixed' ||

          style.position === 'sticky' ||

          Boolean(stickyAncestor);



        if (!isStickyLike) return;



        // Only count header UI that is occupying the top edge of the viewport.

        if (rect.top <= 8 && rect.bottom > 0) {

          visibleBottom = Math.max(visibleBottom, rect.bottom);

        }

      });



      return visibleBottom;

    };



    const updateDesktopStickyOffset = () => {

      if (!desktopSummary) return;



      if (window.innerWidth < 990) {

        desktopSummary.style.removeProperty('--tsob-desktop-sticky-top');

        return;

      }



      const headerBottom = getVisibleHeaderBottom();

      const spacing = 16;

      const stickyTop = Math.max(20, Math.ceil(headerBottom + spacing));



      desktopSummary.style.setProperty(

        '--tsob-desktop-sticky-top',

        `${stickyTop}px`

      );

    };



    let desktopStickyTicking = false;

    let desktopStickySettleTimer;



    const scheduleDesktopStickyOffset = () => {

      if (!desktopStickyTicking) {

        desktopStickyTicking = true;

        window.requestAnimationFrame(() => {

          updateDesktopStickyOffset();

          desktopStickyTicking = false;

        });

      }



      // Re-check once the header's hide/show transition has finished.

      window.clearTimeout(desktopStickySettleTimer);

      desktopStickySettleTimer = window.setTimeout(

        updateDesktopStickyOffset,

        220

      );

    };



    const openDrawer = () => {

      if (!drawer) return;

      drawer.classList.add('is-open');

      drawer.setAttribute('aria-hidden', 'false');

      backdrop?.classList.add('is-open');

      mobileBar?.classList.add('is-drawer-open');

      drawerOpenControl?.setAttribute('aria-expanded', 'true');

      drawer.scrollTop = 0;



      window.setTimeout(() => {

        drawer.querySelector('[data-builder-drawer-close]')?.focus({ preventScroll: true });

      }, 40);

    };



    const closeDrawer = () => {

      if (!drawer) return;

      drawer.classList.remove('is-open');

      drawer.setAttribute('aria-hidden', 'true');

      backdrop?.classList.remove('is-open');

      mobileBar?.classList.remove('is-drawer-open');

      drawerOpenControl?.setAttribute('aria-expanded', 'false');

    };



    const getVariantControl = (context) => context.querySelector('[data-builder-variant]');



    const getVariantData = (context) => {

      const control = getVariantControl(context);

      if (!control) return null;



      if (control.tagName === 'SELECT') {

        const option = control.options[control.selectedIndex];

        if (!option) return null;

        return {

          id: String(option.value),

          price: Number(option.dataset.price || 0),

          available: !option.disabled

        };

      }



      return {

        id: String(control.value),

        price: Number(control.dataset.price || 0),

        available: true

      };

    };



    const getProductTitle = (context) => {

      const key = context.dataset.productKey;

      const card = root.querySelector(`[data-builder-product][data-product-key="${CSS.escape(key)}"]`);

      return card?.dataset.productTitle || 'Product';

    };



    const getSelectedTotal = () => {

      let total = 0;

      selections.forEach((item) => {

        total += item.price * item.quantity;

      });

      return total;

    };



    const getSelectedCount = () => {

      let count = 0;

      selections.forEach((item) => {

        count += item.quantity;

      });

      return count;

    };



    const getQuantity = (variantId) => selections.get(String(variantId))?.quantity || 0;



    const updateVariantPrice = (context) => {

      const variant = getVariantData(context);

      if (!variant) return;

      context.querySelectorAll('[data-builder-price]').forEach((el) => {

        el.textContent = formatMoney.format(variant.price / 100);

      });

    };



    const syncContexts = () => {

      root.querySelectorAll('[data-product-key]').forEach((context) => {

        const variant = getVariantData(context);

        if (!variant) return;

        const quantity = getQuantity(variant.id);

        context.querySelectorAll('[data-builder-quantity]').forEach((output) => {

          output.textContent = quantity;

        });

        updateVariantPrice(context);

      });

    };



    const renderSummary = () => {

      const selectedTotal = getSelectedTotal();

      const combined = cartTotal + selectedTotal;

      const list = root.querySelector('[data-builder-summary-items]');

      const selectedTotalEl = root.querySelector('[data-builder-selected-total]');

      const combinedTotalEl = root.querySelector('[data-builder-combined-total]');

      const addButton = root.querySelector('[data-builder-add-all]');
      const cartCta = root.querySelector('[data-builder-cart-cta]');
      const helper = root.querySelector('.tsob-builder-summary__helper');

      const progress = root.querySelector('[data-builder-progress]');

      const progressFill = root.querySelector('[data-builder-progress-fill]');

      const progressCopy = root.querySelector('[data-builder-progress-copy]');



      if (selectedTotalEl) selectedTotalEl.textContent = formatMoney.format(selectedTotal / 100);

      if (combinedTotalEl) combinedTotalEl.textContent = formatMoney.format(combined / 100);



      if (list) {

        if (selections.size === 0) {

          if (cartItemCount > 0) {

            list.innerHTML = `<p class="tsob-builder-summary__empty">${cartItemCount} item${cartItemCount === 1 ? '' : 's'} already in your cart. Keep building here or review your cart when you're ready.</p>`;

          } else {

            list.innerHTML = '<p class="tsob-builder-summary__empty">Choose a cut to get started.</p>';

          }

        } else {

          list.innerHTML = Array.from(selections.values())

            .filter((item) => item.quantity > 0)

            .map((item) => `

              <div class="tsob-builder-summary__line">

                <span><strong>${escapeHtml(item.title)}</strong><small>Qty ${item.quantity}</small></span>

                <strong>${formatMoney.format((item.price * item.quantity) / 100)}</strong>

              </div>

            `).join('');

        }

      }



      const selectedCount = getSelectedCount();

      if (addButton) {
        addButton.disabled = cartRequestInFlight || selectedCount === 0;
      }

      if (cartCta && !cartRequestInFlight) {
        cartCta.textContent = selectedCount > 0
          ? 'ADD & REVIEW CART'
          : 'REVIEW CART & CHECKOUT';
        cartCta.removeAttribute('aria-disabled');
        cartCta.removeAttribute('aria-busy');
      }

      if (helper) {
        helper.textContent = selectedCount > 0
          ? 'Ready to continue? Your selected items will be added before your cart opens.'
          : "Keep building your order here, or review your cart when you're ready to continue.";
      }



      const percent = threshold > 0 ? Math.min(100, (combined / threshold) * 100) : 100;

      if (progressFill) progressFill.style.width = `${percent}%`;

      if (progress) {

        progress.setAttribute('aria-valuenow', String(Math.round(combined / 100)));

      }



      let progressMessage = '';

      if (combined >= threshold) {

        progressMessage = 'Free shipping threshold reached.';

      } else {

        const remaining = threshold - combined;

        progressMessage = `${formatMoney.format(remaining / 100)} away from free shipping.`;

      }



      if (progressCopy) {

        progressCopy.textContent = progressMessage;

      }



      const mobileCount = root.querySelector('[data-builder-mobile-count]');

      const mobileTotal = root.querySelector('[data-builder-mobile-total]');

      const mobileProgress = root.querySelector('[data-builder-mobile-progress]');

      const totalItemCount = cartItemCount + getSelectedCount();



      if (mobileCount) {

        mobileCount.textContent = `${totalItemCount} ${totalItemCount === 1 ? 'ITEM' : 'ITEMS'}`;

      }

      if (mobileTotal) {

        mobileTotal.textContent = formatMoney.format(combined / 100);

      }

      if (mobileProgress) {

        mobileProgress.textContent = progressMessage;

      }

    };



    const escapeHtml = (value) => String(value)

      .replaceAll('&', '&amp;')

      .replaceAll('<', '&lt;')

      .replaceAll('>', '&gt;')

      .replaceAll('"', '&quot;')

      .replaceAll("'", '&#039;');



    const setQuantity = (context, nextQuantity) => {

      const variant = getVariantData(context);

      if (!variant || !variant.available) return;



      const qty = Math.max(0, Math.min(99, Number(nextQuantity) || 0));

      const key = String(variant.id);



      if (qty === 0) {

        selections.delete(key);

      } else {

        selections.set(key, {

          id: key,

          price: variant.price,

          quantity: qty,

          title: getProductTitle(context)

        });

      }



      syncContexts();

      renderSummary();

    };



    const changeQuantity = (context, amount) => {

      const variant = getVariantData(context);

      if (!variant) return;

      setQuantity(context, getQuantity(variant.id) + amount);

    };



    root.addEventListener('click', (event) => {

      const heroCta = event.target.closest('.tsob-builder__hero-cta');

      if (heroCta) {

        const target = document.getElementById('TSOB-Steak-Products');

        if (target) {

          event.preventDefault();

          target.scrollIntoView({

            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',

            block: 'start'

          });

        }

        return;

      }



      const drawerOpen = event.target.closest('[data-builder-drawer-open]');

      if (drawerOpen) {

        openDrawer();

        return;

      }



      const drawerClose = event.target.closest('[data-builder-drawer-close], [data-builder-drawer-backdrop]');

      if (drawerClose) {

        closeDrawer();

        return;

      }



      const infoButton = event.target.closest('[data-modal-open]');

      if (infoButton) {

        const modal = document.getElementById(infoButton.dataset.modalOpen);

        if (modal?.showModal) {

          const key = modal.dataset.productKey;

          const card = root.querySelector(`[data-builder-product][data-product-key="${CSS.escape(key)}"]`);

          const cardVariant = getVariantControl(card);

          const modalVariant = getVariantControl(modal);

          if (cardVariant && modalVariant) {

            modalVariant.value = cardVariant.value;

            const current = getVariantData(card);

            if (current) modal.dataset.currentVariantId = current.id;

          }

          syncContexts();

          modal.showModal();

          document.documentElement.style.overflow = 'hidden';

        }

        return;

      }



      const closeButton = event.target.closest('[data-modal-close]');

      if (closeButton) {

        const modal = closeButton.closest('dialog');

        modal?.close();

        return;

      }



      const thumb = event.target.closest('[data-modal-image]');

      if (thumb) {

        const modal = thumb.closest('[data-builder-modal]');

        const featured = modal?.querySelector('.tsob-product-modal__featured');

        if (featured) featured.src = thumb.dataset.modalImage;

        modal?.querySelectorAll('[data-modal-image]').forEach((item) => item.classList.remove('is-active'));

        thumb.classList.add('is-active');

        return;

      }



      const increase = event.target.closest('[data-builder-increase]');

      if (increase) {

        const context = increase.closest('[data-product-key]');

        changeQuantity(context, 1);

        return;

      }



      const decrease = event.target.closest('[data-builder-decrease]');

      if (decrease) {

        const context = decrease.closest('[data-product-key]');

        changeQuantity(context, -1);

        return;

      }



      const quickAdd = event.target.closest('[data-builder-quick-add]');

      if (quickAdd) {

        const context = quickAdd.closest('[data-product-key]');

        changeQuantity(context, 1);

        return;

      }



      const modalAdd = event.target.closest('[data-modal-add]');

      if (modalAdd) {

        const context = modalAdd.closest('[data-product-key]');

        const variant = getVariantData(context);

        if (variant && getQuantity(variant.id) === 0) setQuantity(context, 1);

        context.closest('dialog')?.close();

        return;

      }



      const cartCta = event.target.closest('[data-builder-cart-cta]');

      if (cartCta) {
        if (cartRequestInFlight) {
          event.preventDefault();
          return;
        }

        // With no pending builder selections, preserve the link's normal cart behavior.
        if (getSelectedCount() === 0) return;

        // Pending selections must be committed before the shopper leaves the builder.
        event.preventDefault();
        addSelectionsToCart(cartCta, { redirectUrl: cartCta.href });
        return;
      }



      const addAll = event.target.closest('[data-builder-add-all]');

      if (addAll) {
        if (cartRequestInFlight) return;
        addSelectionsToCart(addAll);
        return;
      }

    });



    root.addEventListener('change', (event) => {

      const variantControl = event.target.closest('[data-builder-variant]');

      if (!variantControl) return;



      const context = variantControl.closest('[data-product-key]');

      if (!context) return;



      const key = context.dataset.productKey;

      const oldVariantId = context.dataset.currentVariantId;

      const oldQuantity = oldVariantId ? getQuantity(oldVariantId) : 0;

      const newVariant = getVariantData(context);



      if (oldVariantId && newVariant && oldVariantId !== newVariant.id && oldQuantity > 0) {

        selections.delete(String(oldVariantId));

        selections.set(String(newVariant.id), {

          id: String(newVariant.id),

          price: newVariant.price,

          quantity: oldQuantity,

          title: getProductTitle(context)

        });

      }



      const otherContexts = root.querySelectorAll(`[data-product-key="${CSS.escape(key)}"]`);

      otherContexts.forEach((other) => {

        const control = getVariantControl(other);

        if (control && control.tagName === 'SELECT') control.value = variantControl.value;

        if (newVariant) other.dataset.currentVariantId = newVariant.id;

      });



      syncContexts();

      renderSummary();

    });



    root.querySelectorAll('[data-builder-modal]').forEach((modal) => {

      modal.addEventListener('close', () => {

        document.documentElement.style.overflow = '';

      });



      modal.addEventListener('click', (event) => {

        if (event.target === modal) modal.close();

      });

    });



    const addSelectionsToCart = async (trigger, { redirectUrl = null } = {}) => {
      const items = Array.from(selections.values())
        .filter((item) => item.quantity > 0)
        .map((item) => ({
          id: Number(item.id),
          quantity: item.quantity
        }));



      if (!items.length) {
        if (redirectUrl) window.location.assign(redirectUrl);
        return false;
      }

      if (cartRequestInFlight) return false;
      cartRequestInFlight = true;



      const status = root.querySelector('[data-builder-status]');
      const addButton = root.querySelector('[data-builder-add-all]');
      const cartCta = root.querySelector('[data-builder-cart-cta]');
      const originalTriggerText = trigger?.textContent || '';
      const addedCount = items.reduce((sum, item) => sum + item.quantity, 0);
      const addedTotal = getSelectedTotal();

      if (addButton) {
        addButton.disabled = true;
        addButton.setAttribute('aria-busy', 'true');
      }

      if (cartCta) {
        cartCta.setAttribute('aria-disabled', 'true');
        cartCta.setAttribute('aria-busy', 'true');
      }

      if (trigger === cartCta) {
        cartCta.textContent = 'ADDING & OPENING CART…';
      } else if (trigger) {
        trigger.textContent = 'Adding to cart…';
      }

      if (status) status.textContent = '';



      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items,
            sections: ['cart-icon-bubble']
          })
        });



        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          throw new Error(errorData.description || 'The selected items could not be added.');
        }

        // A successful cart/add.js response means Shopify has committed the items.
        // Clear pending selections immediately so a later UI-refresh failure cannot
        // cause the shopper to retry and accidentally add the same items twice.
        const result = await response.json().catch(() => ({}));
        selections.clear();

        if (result.sections?.['cart-icon-bubble']) {
          try {
            const parser = new DOMParser();
            const html = parser.parseFromString(result.sections['cart-icon-bubble'], 'text/html');
            const incoming = html.querySelector('#cart-icon-bubble');
            const current = document.querySelector('#cart-icon-bubble');
            if (incoming && current) current.replaceWith(incoming);
          } catch (sectionError) {
            console.warn('[TSOB steak builder] Cart icon refresh failed.', sectionError);
          }
        }

        // Refresh authoritative cart totals. If that secondary request fails, use
        // the known amount/count that Shopify just accepted rather than treating
        // the successful add as a failure.
        try {
          const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
            headers: { 'Accept': 'application/json' }
          });

          if (!cartResponse.ok) throw new Error(`Cart refresh failed with ${cartResponse.status}.`);

          const cart = await cartResponse.json();
          cartTotal = Number(cart.total_price || 0);
          cartItemCount = Number(cart.item_count || 0);
        } catch (cartRefreshError) {
          console.warn('[TSOB steak builder] Cart totals refresh failed.', cartRefreshError);
          cartTotal += addedTotal;
          cartItemCount += addedCount;
        }

        syncContexts();
        renderSummary();



        if (status) {
          status.textContent = `${addedCount} item${addedCount === 1 ? '' : 's'} added to your cart. You can keep building or continue when you're ready.`;
        }

        if (cartCta) {
          cartCta.classList.add('is-ready');
        }

        if (redirectUrl) {
          window.location.assign(redirectUrl);
        }

        return true;
      } catch (error) {
        console.error('[TSOB steak builder]', error);
        if (status) status.textContent = error.message || 'Something went wrong. Please try again.';
        return false;
      } finally {
        cartRequestInFlight = false;

        if (addButton) {
          addButton.removeAttribute('aria-busy');
        }

        if (cartCta) {
          cartCta.removeAttribute('aria-disabled');
          cartCta.removeAttribute('aria-busy');
        }

        if (trigger && trigger !== cartCta && originalTriggerText) {
          trigger.textContent = originalTriggerText;
        }

        // Recalculate labels and disabled states from the actual pending selection state.
        renderSummary();
      }
    };



    // Older versions of the "Back to the Steaks" button wrote this anchor into the URL.

    // Strip it on load so opening/shared links begin at the top of the landing page.

    if (window.location.hash === '#TSOB-Steak-Products') {

      history.replaceState(null, '', window.location.pathname + window.location.search);

      requestAnimationFrame(() => window.scrollTo({ top: 0, left: 0, behavior: 'auto' }));

    }



    window.addEventListener('pageshow', () => {

      if (window.location.hash === '#TSOB-Steak-Products') {

        history.replaceState(null, '', window.location.pathname + window.location.search);

        window.scrollTo({ top: 0, left: 0, behavior: 'auto' });

      }

    });



    document.addEventListener('keydown', (event) => {

      if (event.key === 'Escape' && drawer?.classList.contains('is-open')) {

        closeDrawer();

      }

    });



    // More reliable than observing the entire section:

    // show the mobile order bar once the shopper reaches the builder,

    // and hide it again after the builder section is left.

    const productsAnchor = document.getElementById('TSOB-Steak-Products');



    const updateMobileBarVisibility = () => {

      if (!mobileBar) return;



      if (window.innerWidth > 749) {

        mobileBar.classList.remove('is-visible');

        closeDrawer();

        return;

      }



      const rootRect = root.getBoundingClientRect();

      const anchorRect = productsAnchor?.getBoundingClientRect();

      const reachedProducts = anchorRect ? anchorRect.top <= window.innerHeight * 0.72 : true;

      const stillInBuilder = rootRect.bottom > 110;



      mobileBar.classList.toggle(

        'is-visible',

        reachedProducts && stillInBuilder && !drawer?.classList.contains('is-open')

      );

    };



    let mobileBarTicking = false;

    const scheduleMobileBarUpdate = () => {

      if (mobileBarTicking) return;

      mobileBarTicking = true;

      window.requestAnimationFrame(() => {

        updateMobileBarVisibility();

        mobileBarTicking = false;

      });

    };



    window.addEventListener('scroll', scheduleMobileBarUpdate, { passive: true });

    window.addEventListener('resize', scheduleMobileBarUpdate, { passive: true });



    window.addEventListener('scroll', scheduleDesktopStickyOffset, { passive: true });

    window.addEventListener('resize', scheduleDesktopStickyOffset, { passive: true });



    document

      .querySelectorAll('sticky-header, .header-wrapper, [data-sticky-header]')

      .forEach((headerElement) => {

        headerElement.addEventListener('transitionend', scheduleDesktopStickyOffset);

      });



    scheduleMobileBarUpdate();

    scheduleDesktopStickyOffset();



    root.querySelectorAll('[data-product-key]').forEach((context) => {

      const variant = getVariantData(context);

      if (variant) context.dataset.currentVariantId = variant.id;

    });



    syncContexts();

    renderSummary();

  };



  const initAll = () => {

    document.querySelectorAll('[data-tsob-builder]').forEach(initBuilder);

  };



  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', initAll);

  } else {

    initAll();

  }



  document.addEventListener('shopify:section:load', (event) => {

    event.target.querySelectorAll?.('[data-tsob-builder]').forEach(initBuilder);

  });

})();